export default {
  namespaced: true,
  state: {
    messages: [],
    chat: null,
    counter: 0,
  },
  actions: {
    GetChatMessages({ rootGetters, dispatch, commit }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('chats/api/messages/list', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'messages', value: response.data.messages });
              commit('setField', { name: 'chat', value: response.data.chat });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    AddChatMessage({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('chats/api/messages/add', payload)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetChatMessagesCounter({ rootGetters, dispatch, commit }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('chats/api/nolog/get-counter-profile', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'counter', value: response.data.counter_profile });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    SetChatMessagesRead({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('chats/api/messages/readed-by-profile', payload)
          .then(() => { resolve(true); })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    UpdateChat({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('chats/api/nolog/update-my-online', payload)
          .then(() => { resolve(true); })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    Clear({ commit }) {
      commit('setField', { name: 'messages', value: [] });
      commit('setField', { name: 'chat', value: null });
      commit('setField', { name: 'counter', value: 0 });
    },
  },
  mutations: {
    setField(state, payload) { state[payload.name] = payload.value; },
  },
};
